import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createTreatmentReport, type TreatmentReportUpdatePayload } from '@/services/main/treatmentReport';
import { useClinicContext } from './useClinicContext';
import { useClinicPortalServiceType } from './clinicPortalServiceType';

export const useCreateTreatmentReport = (patientId?: string) => {
  const { tenant, clinicNumber } = useClinicContext();
  const serviceType = useClinicPortalServiceType();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TreatmentReportUpdatePayload) =>
      createTreatmentReport(
        tenant! || '',
        clinicNumber! || '',
        patientId!,
        serviceType,
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['treatment-reports'] });
      queryClient.invalidateQueries({ queryKey: ['rezept', 'list', tenant, clinicNumber] });
    },
  });
};
